import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	GetRefreshSessionError,
} from '@exceptions/GetRefreshSessionError';
import {
	GetSessionError,
} from '@exceptions/GetSessionError';
import {
	getURL,
} from '@modules/utils';
import {
	FETCHES,
} from '@routes/fetches';

export const getSession = async () => await fetch(getURL(FETCHES.public.me), {
	...APP_CONF_VARS.request.default,
}).then((response) => response.json()).catch((err) => {
	throw new GetSessionError(err);
});

export const refreshSession = async () => await fetch(getURL(FETCHES.public.session), {
	...APP_CONF_VARS.request.default,
}).then((response) => response.json()).catch((err) => {
	throw new GetRefreshSessionError(err);
});
